function MonitoredEventNote(aMonitoredEventNoteId) {
    this.__type = 'MonitoredEventNote:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;
    this.UpdatedUTC = (new Date()).toWcf();
    this.EventId = -1;
    this.UserId = -1;
    this.CreatedDateUTC = (new Date()).toWcf();
    this.MonitoredEventNote = '';
}
if (typeof exports !== 'undefined') {
    module.exports = MonitoredEventNote;
}